/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Has_AccountInputs */

const en_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account? `)
};

const de_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du bereits ein Konto? `)
};

const fr_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as déjà un compte ?`)
};

const es_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tiene una cuenta? `)
};

const it_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già un account? `)
};

const nl_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heb je al een account? `)
};

const pl_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masz już konto? `)
};

const fi_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onko sinulla jo tili? `)
};

const da_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du allerede en konto? `)
};

const sv_auth_has_account = /** @type {(inputs: Auth_Has_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du redan ett konto? `)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Has_AccountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_has_account = /** @type {((inputs?: Auth_Has_AccountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Has_AccountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_has_account(inputs)
	if (locale === "fr") return fr_auth_has_account(inputs)
	if (locale === "es") return es_auth_has_account(inputs)
	if (locale === "it") return it_auth_has_account(inputs)
	if (locale === "nl") return nl_auth_has_account(inputs)
	if (locale === "pl") return pl_auth_has_account(inputs)
	if (locale === "fi") return fi_auth_has_account(inputs)
	if (locale === "da") return da_auth_has_account(inputs)
	if (locale === "sv") return sv_auth_has_account(inputs)
	return en_auth_has_account(inputs)
});